/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import FinautaWhiteLogo from '../../images/svgs/finauta/logo-white.svg';
import { WhiteLogo, StyledResults } from './resultsStyles';
import { FlowHeader } from '../GoalsFlow/styles';
import Title from './Title';
import Text from './Text';
import { mp, getCampaign } from '../../constants/utils';
import { breakpoints } from '../../constants/styles';

const StyledErrorContent = styled.div`
  margin-top: 30px;
  height: fit-content;
  justify-content: flex-start;
  background-color: white;

  ${breakpoints.tablet} {
    width: 60%;
    max-width: 500px;
    margin-right: auto;
    margin-left: auto;
  }

  height: 100vh;
  padding: 20px;
`;

class Error extends Component {
  state = {
    errorText: '',
  };

  componentWillMount = () => {
    const { match } = this.props;
    mp(`[${getCampaign(window.location.href)}] | Error | ${match.params.number}`);
    this.initializeErrorText(match.params.number);
  };

  getRetirementPercentage = tasaDeRemplazo => {
    let retirementPercentage = tasaDeRemplazo * 100;
    if (retirementPercentage > 100) retirementPercentage = 100;
    return retirementPercentage;
  };

  initializeErrorText = errorNumber => {
    let errorText;
    switch (parseInt(errorNumber, 10)) {
      case 404:
        errorText = 'Esta página/plan/resultado no existe';
        break;
      case 511:
        errorText = 'Hubo un problema de conexión con el servidor';
        break;
      default:
        errorText = 'Un error inesperado sucedió';
        break;
    }
    this.setState({ errorText, errorNumber });
  };

  render() {
    const { errorText, errorNumber } = this.state;

    return (
      <StyledResults fullscreen>
        <FlowHeader>
          <Link to="/" onClick={this.forceUpdate}>
            <WhiteLogo src={FinautaWhiteLogo} id="logo" />
          </Link>
        </FlowHeader>
        <StyledErrorContent>
          <Title level={2}>Error #{errorNumber}</Title>
          <Text type="body1">{errorText}</Text>
        </StyledErrorContent>
      </StyledResults>
    );
  }
}

Error.propTypes = {
  errorNumber: PropTypes.number,
};

Error.defaultProps = {
  errorNumber: 404,
};

export default Error;
